import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 22997 22997"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0{stroke:#000;stroke-width:333.285;stroke-linecap:round;stroke-linejoin:round}.fil0{fill:none}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528312225616">
        <path
          d="M167 167h22663v1863H167zM22830 22536V1961M17294 22536c345 0 345 118 691 118 345 0 345-118 691-118 345 0 345 118 691 118s346-118 692-118c345 0 345 118 691 118s346-118 692-118c347 0 347 118 694 118s347-118 694-118M19508 12899c-2214 3527-2214 9637-2214 9637M13589 2255s442 7458 5943 10598c0 0 1932-288 3298-1489"
          className="fill-none stroke1"
          style={{
            strokeWidth: 616.388,
            strokeLinejoin: "round",
          }}
        />
        <path
          d="M17107 7556c883 1757 2230 3524 4277 4693M18697 14475s2779 0 4133-1622M167 22712V2138M5703 22712c-346 0-346 118-691 118-346 0-346-118-691-118-346 0-346 118-691 118-346 0-346-118-692-118s-346 118-691 118c-346 0-346-118-692-118-347 0-347 118-694 118s-347-118-694-118M3488 13075c2215 3528 2215 9637 2215 9637M9408 2432s-443 7458-5943 10597c0 0-1932-288-3298-1489"
          className="fill-none stroke1"
          style={{
            strokeWidth: 616.388,
            strokeLinejoin: "round",
          }}
        />
        <path
          d="M5890 7732c-883 1758-2230 3524-4277 4693M4299 14651s-2778 0-4132-1622"
          className="fill-none stroke1"
          style={{
            strokeWidth: 616.388,
            strokeLinejoin: "round",
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
